export const redirectToSigningUrl = (signingUrl: string): void => {
  const backendBaseUrl = (import.meta.env.VITE_BACKEND_ENDPOINT ?? "").replace(
    /\/$/,
    "",
  );
  const signingPath = signingUrl.startsWith("/")
    ? signingUrl
    : `/${signingUrl}`;
  window.location.href = `${backendBaseUrl}${signingPath}`;
};
